import React from 'react';
import styled from 'styled-components';

interface PropType {
  background: string;
  borderColor?: string;
}

export default function ColumnOverlay({ background, borderColor }: PropType): JSX.Element {
  return (
    <div
      style={{
        backgroundColor: background,
        border: ` 2px dashed ${borderColor}`,
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1,
        opacity: 1,
        borderRadius: 10,
      }}
    ></div>
  );
}
